import Footer from "../../components/Footer";
import TopHeader from "../../components/TopHeader";

const FraisDoc = () => {
  return (
    <>
      <TopHeader btn={true} />
      <div className="container mt-40 mb-80">
        <div className="col-md-8 mx-auto">
          <h2 className="grey500">Frais de services & Protection acheteurs</h2>
          <div className="mt-40">
            <p className="body grey66 mt-16">
              Nous avons à cœur d'offrir un cadre de réservation sécurisé, fiable
              et transparent à chaque utilisateur. Les frais de service appliqués
              lors de chaque commande participent activement à la qualité de
              l'expérience, tout en intégrant une protection complète des
              acheteurs et une politique de remboursement claire.
            </p>

            <p className="body grey66 mt-16">
              Frais de service :
            </p>
            <p className="body grey66 mt-16">
              Les frais de service financent les ressources indispensables au bon
              fonctionnement de la plateforme et à la sécurisation de vos
              transactions :
            </p>
            <ul className="body grey66 mt-16">
              <li>Infrastructure de paiement en ligne sécurisée</li>
              <li>Garantie d'intervention en cas de litige ou d'annulation</li>
              <li>Accès à un système de réservation fluide, intuitif et performant</li>
              <li>Support client réactif et personnalisé</li>
              <li>Synchronisation en temps réel des disponibilités des professionnels</li>
              <li>Maintenance technique et amélioration continue de la plateforme</li>
            </ul>

            <p className="body grey66 mt-16">
              Montant des frais :
            </p>
            <p className="body grey66 mt-16">
              Les frais de service Twyny s'élèvent à 5,5 % du prix du service
              réservé.
            </p>
            <p className="body grey66 mt-16">
              Ils sont clairement indiqués au moment du paiement et intégrés au
              montant final.
            </p>

            <p className="body grey66 mt-16">
              Exemple :
            </p>
            <ul className="body grey66 mt-16">
              <li>Service : 50.00 €</li>
              <li>Frais de service : 2.75 €</li>
              <li>Total : 52,75 €</li>
            </ul>

            <p className="body grey66 mt-16">
              Protection des acheteurs :
            </p>
            <p className="body grey66 mt-16">
              Chaque réservation réalisée via Twyny est automatiquement couverte
              par notre protocole de protection acheteur.
            </p>
            <p className="body grey66 mt-16">
              Ce dispositif inclut :
            </p>
            <ul className="body grey66 mt-16">
              <li>Paiement sécurisé : le professionnel est rémunéré uniquement après réalisation du service</li>
              <li>Assistance proactive : accompagnement en cas d'annulation ou de litige</li>
              <li>Reprogrammation facilitée : proposition de nouvelles dates ou d'un autre professionnel</li>
              <li>Remboursement intégral si la prestation ne peut être honorée</li>
              <li>Évaluations post-prestation pour garantir la qualité des services référencés</li>
            </ul>

            <p className="body grey66 mt-16">
              Politique d'annulation et de remboursement
            </p>
            <p className="body grey66 mt-16">
              Notre politique d'annulation est conçue pour offrir une protection
              équitable aux clients comme aux prestataires de services en cas de
              changement de plan. Nous comprenons que des imprévus peuvent
              survenir, c'est pourquoi nous avons mis en place des règles
              d'annulation.
            </p>

            <p className="body grey66 mt-16">
              Conditions d'Annulation :
            </p>
            <ul className="body grey66 mt-16">
              <li>Vous pouvez annuler votre rendez-vous jusqu'à 48 heures avant l'heure prévue. Vous êtes automatiquement remboursés à 94,5% (hors frais de service).</li>
              <li>Pour toute annulation effectuée dans les 48 heures précédant le rendez-vous, aucun remboursement ne sera possible.</li>
              <li>Pour toute non-présentation le jour J (no-show), aucun remboursement ne sera possible.</li>
            </ul>

            <p className="body grey66 mt-16">
              Procédure pour Annuler un Service :
            </p>
            <ol className="body grey66 mt-16">
              <li>Connectez-vous à votre compte Twyny.</li>
              <li>Accédez à la section « Mes rendez-vous ».</li>
              <li>Trouvez la prestation de service que vous souhaitez annuler et cliquez sur « Annuler le rdv ».</li>
            </ol>

            <p className="body grey66 mt-16">
              Les annulations du fait des professionnels :
            </p>
            <p className="body grey66 mt-16">
              Les professionnels ne peuvent annuler une prestation réservée et
              confirmée que dans les cas où des circonstances imprévisibles ne
              permettent pas la réalisation du service. Dans ce cas, les
              utilisateurs sont automatiquement et intégralement remboursés de la
              valeur du service réservé.
            </p>
            <p className="body grey66 mt-16">
              Les professionnels peuvent aussi proposer de nouvelles dates pour
              réaliser la prestation auquel cas c'est l'utilisateur qui décide
              s'il accepte ou non de décaler la réalisation de l'activité. Si vous
              n'êtes pas disponible aux nouvelles dates proposées par le
              professionnel, vous serez intégralement remboursé de la valeur de la
              prestation réservée.
            </p>

            <p className="body grey66 mt-16">
              Reprogrammation :
            </p>
            <p className="body grey66 mt-16">
              Il est tout à fait possible de demander à modifier la date prévue
              pour réaliser la prestation, si cela est techniquement faisable et
              compatible avec l'activité du professionnel.
            </p>

            <p className="body grey66 mt-16">
              Procédure pour Modifier un Service :
            </p>
            <ol className="body grey66 mt-16">
              <li>Connectez-vous à votre compte Twyny.</li>
              <li>Accédez à la section « Mes rendez-vous »</li>
              <li>Trouvez la prestation de service que vous souhaitez modifier et cliquez sur « Reprogrammer le rendez-vous ».</li>
            </ol>

            <p className="body grey66 mt-16">
              Vous recevrez un nouveau récapitulatif de réservation par e-mail
              avec la nouvelle date et le nouvel horaire, le cas échéant.
            </p>
            <p className="body grey66 mt-16">
              Il est cependant important de signaler que les professionnels ne
              sont en aucun cas obligés d'accepter ces demandes de modifications,
              qui peuvent interférer avec d'autres réservations déjà dans leur
              agenda. Par ailleurs, de telles modifications peuvent donner lieu
              aux paiements de frais, selon les conditions particulières
              éventuelles du professionnel.
            </p>
            <p className="body grey66 mt-16">
              Dans le cas où votre demande de modification est refusée par le
              professionnel, celle-ci sera traitée comme une annulation et
              rentrera dans le champ général d'application des annulations comme
              détaillé au-dessus.
            </p>

            <p className="body grey66 mt-16">
              Besoin d'Assistance ?
            </p>
            <p className="body grey66 mt-16">
              Gérez vos rendez-vous depuis votre espace client Twyny → "Mes
              rendez-vous" Accédez à notre FAQ ou contactez notre support via la
              rubrique "Assistance"
            </p>

            <p className="body grey66 mt-32">
              <b>Document applicable à compter du 01 juin 2025</b>
            </p>
            <p className="body grey66 mt-16">
              <i>© Twyny – Tous droits réservés</i>
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default FraisDoc;